module.exports = __webpack_public_path__ + "static/media/upload-product.694e8869.svg";